import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const IntimateBuildingIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M6.597 1.5a2.403 2.403 0 0 0-2.386 2.122l-.854-.854L1 5.126v3.847h4.806V6.17c.173.06.352.101.534.12v2.69h.534V6.29a2.403 2.403 0 0 0-.277-4.79ZM5.272 8.44H1.534V5.346l1.823-1.822 1.915 1.914v3.004-.002Zm1.602-2.698v-.707L7.9 4.011l-.379-.377-.646.646V3.093H6.34v2.652a1.82 1.82 0 0 1-.534-.159v-.37l-1.05-1.05a1.862 1.862 0 1 1 2.119 1.576Z" />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const IntimateBuildingIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M6.597 1.5a2.403 2.403 0 0 0-2.386 2.122l-.854-.854L1 5.126v3.847h4.806V6.17c.173.06.352.101.534.12v2.69h.534V6.29a2.403 2.403 0 0 0-.277-4.79ZM5.272 8.44H1.534V5.346l1.823-1.822 1.915 1.914v3.004-.002Zm1.602-2.698v-.707L7.9 4.011l-.379-.377-.646.646V3.093H6.34v2.652a1.82 1.82 0 0 1-.534-.159v-.37l-1.05-1.05a1.862 1.862 0 1 1 2.119 1.576Z" />
        </SvgIcon>
    );
};
